import { TemplateEventInfo } from '@/types/template.types';
import { Put } from './helpers';
import { GetEventsResponse } from '@/types/projects.types';

export const CreateTemplateProject = async ({
  channel,
  projectUuid,
  templateInfo,
}: {
  channel: number;
  projectUuid: string;
  templateInfo: TemplateEventInfo;
}): Promise<GetEventsResponse> => {
  return Put({
    path: `/v3/admin/channel/${channel}/template-event/${projectUuid}`,
    body: templateInfo,
  });
};
